import { Link } from "react-router-dom";
import { Mail, ExternalLink } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-auto py-12 border-t border-white/10 bg-black/20 backdrop-blur-sm">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link
              to="/"
              className="text-lg font-semibold flex items-center space-x-2"
            >
              <img 
                src="/lovable-uploads/696668bf-afe7-4791-9555-262f2b681308.png" 
                alt="ThePromptSpace Logo" 
                className="h-8 w-auto"
              />
              <span className="bg-gradient-to-r from-[#00C2FF] to-[#7000FF] bg-clip-text text-transparent">
                ThePromptSpace
              </span>
            </Link>
            <p className="mt-3 text-white/60 text-sm leading-relaxed">
              The future of GenAI creation — giving every asset ownership, discoverability, and GEO-driven performance.
            </p>
          </div>
          
          {/* Product */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Product</h3>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <Link to="/prompts" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Explore Prompts
                </Link>
              </li>
              <li>
                <Link to="/create-prompt" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Create Prompts
                </Link>
              </li>
              <li>
                <Link to="/groups" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Groups
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Resources</h3>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <Link to="/docs" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/donate" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Support Us
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Community */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Community</h3>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <a 
                  href="https://discord.gg/Amtkdgf9Jc" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#00C2FF] transition-colors duration-300 inline-flex items-center gap-1"
                >
                  Discord
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a 
                  href="https://x.com/thepromptspace" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#00C2FF] transition-colors duration-300 inline-flex items-center gap-1"
                >
                  Twitter / X
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/thepromptspace" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#00C2FF] transition-colors duration-300 inline-flex items-center gap-1"
                >
                  Instagram
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-sm text-white">Legal</h3>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <Link to="/terms" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Cookies
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="hover:text-[#00C2FF] transition-colors duration-300">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Contact Row */}
        <div className="mt-10 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="flex flex-wrap items-center gap-4 text-sm text-white/50">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a href="mailto:hello@thepromptspace.com" className="hover:text-[#00C2FF] transition-colors">
                  hello@thepromptspace.com
                </a>
              </div>
              <span className="hidden md:inline">•</span>
              <a href="mailto:thepromptspace@gmail.com" className="hover:text-[#00C2FF] transition-colors">
                thepromptspace@gmail.com
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-white/10">
          <p className="text-sm text-white/40 text-center">
            © {new Date().getFullYear()} ThePromptSpace. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
